import React, { Component } from 'react';
import printJS from 'print-js';
import { Alert } from 'reactstrap';
import axios from 'axios';
import LoadingButton from './common/LoadingButton';

type RequestPinState = {
    error: string | null;
};

export default class RequestPin extends Component<{}, RequestPinState> {
    state: RequestPinState = {
        error: null,
    }

    static displayName = RequestPin.name;

    printRequestForm = async (): Promise<boolean> => {
        const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') || '';
        const formPath = 'PinRequestForm/GRPINRequestForm.pdf';
        const printPath = `${baseUrl.replace(/\/$/g, '')}/${formPath}`; // trim base url trailing slash
        try {
            await axios.get(formPath);
            printJS(printPath);
            this.setError(null);
        } catch (e) {
            this.setError("There was an error loading the PIN Request form.  Please contact the tax office.");
        }
        return false;
    }

    setError = (error: string | null) => this.setState({ error: error });

    render() {
        return (
            <div>
                {this.error}
                <div className="print-button-container">
                    <LoadingButton className="print-pin-request-button" onClick={this.printRequestForm} label="Print PIN Request Form" />
                </div>
            </div>
        );
    }

    get error() {
        return this.state.error ?
            (
                <Alert color="danger">
                    {this.state.error}
                </Alert>
            ) :
            (<></>)
    };
}
